export const SET_LOADING_STATE = "SET_LOADING_STATE";
export const SET_RECAPTCHA_RESPONSE = "SET_RECAPTCHA_RESPONSE";
export const SET_LIMAN = "SET_LIMAN";
export const GET_LIMANLAR = "GET_LIMANLAR";
export const WILL_GET_ALL = "WILL_GET_ALL";
export const SET_BASLANGIC_TARIHI = "SET_BASLANGIC_TARIHI";
export const SET_BITIS_TARIHI = "SET_BITIS_TARIHI";
export const SET_TICARET_TIPI = "SET_TICARET_TIPI";
export const SET_GEMİ_ADI = "SET_GEMİ_ADI";
export const KUR_GUNCELLE = "KUR_GUNCELLE";
export const SET_SEFERLER = "SET_SEFERLER";
export const SET_SEFER_FRW_LIST = "SET_SEFER_FRW_LIST";


// WEBPACK FOOTER //
// ./src/actions/ActionType.js